export default "__VITE_ASSET__CDyrDBDG__"